/* src/app/modules/taxes/model-184/model-184.component.css */
:host {
  --m184-brand: #e3fd64;
  --m184-brand-d: #4d7a00;
  --m184-brand-bg: rgba(227, 253, 100, 0.08);
  --m184-text: #1a1d23;
  --m184-muted: #6b7280;
  --m184-border: #e5e7eb;
  --m184-surface: #ffffff;
  --m184-radius: 10px;
  --m184-shadow: 0 2px 8px rgba(0,0,0,0.07);
  display: block;
}
.m184-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.m184-header {
  display: flex;
  align-items: center;
  gap: 14px;
}
.m184-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--m184-brand-bg);
  flex-shrink: 0;
}
.m184-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.m184-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--m184-text);
  line-height: 1.2;
}
.m184-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--m184-muted);
}
.m184-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.m184-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px !important;
}
.m184-alerts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.m184-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: rgba(227, 253, 100, 0.1);
  border: 1px solid rgba(227, 253, 100, 0.4);
  border-left: 4px solid var(--m184-brand);
  border-radius: var(--m184-radius);
}
.m184-alert__text {
  font-size: 13px;
  color: var(--m184-text);
}
.m184-alert__link {
  font-size: 12px;
  font-weight: 600;
  color: var(--m184-brand-d);
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: none;
  padding: 0;
}
.m184-alert__link:hover {
  text-decoration: underline;
}
.m184-card {
  background: var(--m184-surface);
  border: 1px solid var(--m184-border);
  border-radius: var(--m184-radius);
  box-shadow: var(--m184-shadow);
  overflow: hidden;
}
.m184-card + .m184-card {
  margin-top: 16px;
}
.m184-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--m184-brand);
}
.m184-card__head mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--m184-brand-d);
  opacity: .9;
}
.m184-card__head-label {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--m184-brand-d);
}
.m184-card__body {
  padding: 16px;
}
.m184-subhead {
  display: block;
  background: var(--m184-brand);
  color: var(--m184-brand-d);
  padding: 8px 12px;
  font-weight: 600;
  font-size: 13px;
  border-radius: 6px;
  margin: 4px 0 12px;
}
.m184-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
}
.m184-fields > * {
  flex: 1 1 200px;
  min-width: 0;
}
.m184-fields app-input,
.m184-fields app-select {
  display: block;
  width: 100%;
}
.m184-field-label {
  display: block;
  font-size: 12px;
  color: var(--m184-muted);
  margin-bottom: 4px;
}
.m184-check-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  font-size: 13px;
  color: var(--m184-text);
}
.m184-table-wrap {
  overflow-x: auto;
}
.m184-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.m184-table th,
.m184-table td {
  padding: 7px 10px;
  border-bottom: 1px solid var(--m184-border);
  color: var(--m184-text);
  vertical-align: middle;
}
.m184-table th {
  font-size: 11px;
  font-weight: 600;
  color: var(--m184-muted);
  background: #f9fafb;
  text-align: left;
}
.m184-table tr:last-child td {
  border-bottom: none;
}
.m184-list-empty {
  padding: 16px;
  text-align: center;
  font-size: 13px;
  color: var(--m184-muted);
}
.m184-row-actions {
  display: flex;
  gap: 8px;
}
.m184-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 12px;
  margin-top: 8px;
  border-top: 1px solid var(--m184-border);
}
.m184-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 24px;
}
.m184-loading p {
  margin: 0;
  font-size: 14px;
  color: var(--m184-muted);
}
.m184-card__body .form-control,
.m184-modal .form-control {
  border: 1px solid var(--m184-border);
  border-radius: 6px;
  font-size: 13px;
  padding: 6px 10px;
  color: var(--m184-text);
  background: #fff;
}
.m184-card__body .form-control:focus,
.m184-modal .form-control:focus {
  outline: none;
  border-color: var(--m184-brand);
  box-shadow: 0 0 0 2px rgba(227, 253, 100, 0.35);
}
.m184-card__body span,
.m184-modal span {
  font-size: 12px;
  color: var(--m184-muted);
  display: block;
  margin-bottom: 2px;
}
.m184-card__body .mat-mdc-tab-body-content {
  overflow-x: hidden;
}
/*# sourceMappingURL=model-184.component.css.map */
